import FileSelectionFilter from '../store/schema/FileSelectionFilter';
import { FileProviderType } from '../utils/constants';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

// To add support for various providers add the filters in this mapping
const supportedFileSelectionFiltersForProvider = {};
supportedFileSelectionFiltersForProvider[AttachmentDataProviderType.OneDriveConsumer] = [
    FileSelectionFilter.Images,
];

export default function getSupportedFileSelectionFilters(
    providerType: FileProviderType
): FileSelectionFilter[] {
    if (providerType in supportedFileSelectionFiltersForProvider) {
        return supportedFileSelectionFiltersForProvider[providerType];
    }

    return [];
}
